const it = {
  lng_name: 'Italiano',
  item_id_does_not_exist: `L'elemento {{id}} non esiste nell'elenco dei tuoi oggetti Kaltura o è stato eliminato.`,
  your_kaltura_item_list_is_empty: `L'elenco dei tuo elementi Kaltura è vuoto.`,
  purchase: 'acquista',
  purchased: 'acquistato',
  go_to: 'Vai a',
  login_signup: 'Accedi/Registrati',
  logout: 'Disconnetti',
  please_wait: 'Attendi...',
  thank_you_for_your_purchase: 'Grazie per il tuo acquisto',
  buy_more_channels: 'Acquista altri canali',
  go_to_premium_content: 'Vail al contenuto premium',
  go_to_purchased_channels: 'Vai ai canali acquistati',
};

export default it;